export const resolutions = {
  tabletSMin: '768px',
  tabletSMax: '991.98px',

  tabletMin: '992px',
  tabletMax: '1199.98px',

  desktopMin: '1200px',
};
